<template>
   <h1 id="page-title" class="content__title">Not Found</h1>
</template>
 
<script>
export default {
   name: 'NotFound',
};
</script>
 